// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CalendarSubtractIconSignature {
  Element: SVGSVGElement;
}

export const CalendarSubtractIcon: TOC<CalendarSubtractIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 18H14V20H2C0.897 20 0 19.103 0 18V5C0 3.898 0.897 3 2 3H4V5H5V0H7V3H14V5H15V0H17V3H18C19.103 3 20 3.898 20 5V17H17.997L17.999 8H2V18ZM22 18.995H16V20.995H22V18.995Z"/>
</svg>
</template>;